const DataStoreNames = require('@/lib/DataStores/DataStoreNames');

/**
 * Logic to test IndexedDB.
 * Note this is not a unit test, it is code that runs in production to check the user's browser is supported.
 *
 * @constructor
 *
 * @param {DataStore} dataStore
 */
const DataStoreTester = function (
    dataStore
) {
    this.delete = async () => {
        return dataStore.deleteDB();
    };

    /**
     * Test that IndexedDB is available and working by writing then reading back a small piece of test data.
     *
     * @return {Promise}
     */
    this.test = async () => {
        // Use a unique name so two tests running at the same time cannot overwrite each other's data.
        // See https://digitickets.atlassian.net/browse/PROP-3019
        const name = 'testString-' + crypto.randomUUID();
        const testData = {
            name,
            value: (new Date()).toISOString(),
        };

        console.debug('Testing IndexedDB support', 'Test data:', testData);

        // Check if indexedDB is available at all.
        // The check for 'window' is here so this doesn't break tests running in Node.
        /* istanbul ignore if */
        if (typeof window !== 'undefined') {
            console.debug(
                'typeof window.indexedDB ',
                typeof window.indexedDB,
                '!!window.indexedDB',
                !!window.indexedDB
            );

            if (!window.indexedDB) {
                throw new Error('window.indexedDB is empty.');
            }
        }

        try {
            const persistResult = await dataStore.persist(
                DataStoreNames.TEST,
                testData
            );
            console.debug('Testing IndexedDB support', 'Persist result:', persistResult);

            const findResult = await dataStore.find(DataStoreNames.TEST, testData.name);
            console.debug('Testing IndexedDB support', 'Find result:', findResult);

            if (findResult && findResult.value === testData.value) {
                // Successfully read back the same value. Successful test.
                return true;
            }

            // Reject the promise by throwing an error.
            throw new Error(
                `Returned value '${JSON.stringify(findResult)}' does not match the expected '${JSON.stringify(testData)}'`
            );
        } finally {
            // Clean up the test row we wrote. Ignore any errors cleaning up so these don't affect normal operations.
            try {
                await dataStore.removeMany(DataStoreNames.TEST, [testData.name]);
            } catch (e) {
                console.warn(
                    `Failed to remove IndexedDB test data '${testData.name}'`,
                    e
                );
            }
        }
    };
};

module.exports = DataStoreTester;
